module.exports = __webpack_public_path__ + "static/media/emilMichaelFrank.60e76aa7.png";